
import api from '@/services/api';
import _ from 'underscore';
import Certificate from '@/classes/Certificate';
import { Module } from 'vuex';
import { RootState } from '@/types';
import Certification from '@/classes/Certification';
import { sprintf } from 'sprintf-js';

export interface CertificateState {
  certificates: Certificate[];
}

export const CertificateStore: Module<CertificateState, RootState> = {
  namespaced: true,

  state: {
    certificates: []
  },

  getters: {

    getCertificationsByIds: (state, getters, rootState, rootGetters) => (ids: number[]) => {

      if (_.isEmpty(ids)) {
        return [];
      }

      const certIds = _.chain(state.certificates)
        .filter((c: Certificate) => {
          return _.contains(ids, c.id);
        })
        .pluck('certificationId')
        .uniq()
        .value();

      if (_.isEmpty(certIds)) {
        return [];
      }

      const certifications = rootGetters['certifications/getCertifications'] as Certification[];

      return _.isEmpty(certifications) ? [] :
        _.filter(certifications, (c: Certification) => {
          return _.contains(certIds, c.id);
        });
    },

    getCertificatesByIds: (state) => (ids: number[]) => {
      return _.isEmpty(ids) ? [] : _.filter(state.certificates, (c: Certificate) => {
        return _.contains(ids, c.id);
      });
    },
    getCertificateFormIdsByStudentIds: (state) => (studentIds: number[]): number[] => {
      if (state.certificates !== undefined && state.certificates !== null) {
        return state.certificates.filter((c: Certificate) => {
          if (c.studentId) {
            return studentIds.includes(c.studentId);
          } else {
            return false;
          }
        }).map((cert: Certificate): number => cert.certificateFormId as number);
      } else {
        return [];
      }
    },
    getCertificateFormIdsByJobCorpId: (state) => (jobCorpCenterId: number): number[] => {
      if (state.certificates !== undefined && state.certificates !== null) {
        return state.certificates.filter((c: Certificate) => {
          if (c.studentId) {
            return jobCorpCenterId === c.studentId;
          } else {
            return false;
          }
        }).map((cert: Certificate): number => cert.certificateFormId as number);
      } else {
        return [];
      }
    }
  },

  mutations: {
    setCertificates(state, certificates: Certificate[]) {
      state.certificates = certificates;
    },

    removeCertificate(state, certificate: Certificate) {

      const idx = _.findIndex(state.certificates, (c: Certificate) => {
        return c.id === certificate.id;
      });

      if (idx >= 0) {
        state.certificates.splice(idx, 1);
      }
    },

    updateCertificateDate(state, certificate: Certificate) {
      certificate.certificationDate = certificate.editCertificationDate;
    }
  },

  actions: {
    removeCertificate(state, certificate: Certificate) {
      return new Promise((resolve, reject) => {

        api().delete(sprintf('/certificate/%d', certificate.id))
          .then((response) => {
            state.commit('removeCertificate', certificate);
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    saveCertificateDate(state, certificate: Certificate) {

      const c = new Certificate();
      c.id = certificate.id;
      c.studentId = certificate.studentId;
      c.certificationDate = certificate.editCertificationDate;

      return new Promise((resolve, reject) => {

        if (_.isEmpty(c.certificationDate)) {
          return reject(new Error('The Completion Date cannot be empty.'));
        }

        api().post('/certificate/date', c)
          .then((response) => {
            state.commit('updateCertificateDate', certificate);

            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }
};
